import Marketing from "@material-symbols/svg-500/rounded/bar_chart_4_bars.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const MarketingIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Marketing });
	return <Icon />;
};

export default memo(MarketingIcon);
